import { render, staticRenderFns } from "./AssignmentDialog.vue?vue&type=template&id=49c1abf0&"
import script from "./AssignmentDialog.vue?vue&type=script&lang=js&"
export * from "./AssignmentDialog.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports